module.exports = __webpack_public_path__ + "static/media/print.afb23299.jpg";